import React from 'react';
import PreviewImage from '../PreviewImage';
import styles from './Options.module.sass';
import Image from '../Image/Image';
import cn from 'classnames';
import classPic from '../../assets/class_pic.png';

const Option = ({ option, backgroundUrl, foregroundUrl, hasCustomImage, accessCodeOnly }) => {
  const displayType = option.displayType.toUpperCase();

  const numberOfImagesPerPackage = {
    'A': 3,
    'B': 2,
    'C': 17,
    'D': 1,
    'E': 2,
    'F': 8,
    'CLASS_PIC': 1
  }

  const numberOfImages = () => numberOfImagesPerPackage[displayType] || 1;

  if (hasCustomImage) {
    return (
      <div className={cn(styles.container, styles.custom)}>
        <Image src={foregroundUrl} classes={styles.img} />
      </div>
    )
  }

  return (
    <div className={styles.container}>
      {[...Array(numberOfImages()).keys()].map((i) => {
        if (displayType === 'CLASS_PIC') {
          return (
            <div className={styles.image}>
              <Image src={classPic} />
            </div>
          )
        }

        return (
          <PreviewImage
            foregroundUrl={foregroundUrl}
            backgroundUrl={backgroundUrl}
            containerClass={styles[`image${displayType}${i}`] || styles.image}
            key={i}
            accessCodeOnly={accessCodeOnly}
          />
        )
      })}
    </div>
  )
}

export default Option;
